import refreshToken from "@/utils/refreshToken.js";
import axios from "axios";
import router from './router.js';
import store from '@/store';
import instance from "@/module_user/api/api.js";

let baseUrl = process.env.VUE_APP_API_URL;
let baselineMachineUrl = process.env.VUE_APP_BASELINE_MACHINE_URL;

async function getAllCampaignDetails(data) {
    return await axios.get(baseUrl + `/campaign-admin/?pageSize=${data.pageSize}&page=${data.page}`);
}
async function deleteCampaign(id) {
    let response=await axios.delete(baseUrl + "/campaign-admin/" + id);
    return(response)
}
async function updateCampaign(id,data) {
    let response=await axios.put(baseUrl + "/campaign-admin/" + id,data);
    return(response)
}
async function createCampaign(data) {
    let response=await axios.post(baseUrl + "/campaign-admin" ,data);
    return(response)
}``
async function getCampaignById(id){
    let response=await axios.get(baseUrl+"/campaign-admin/"+id);
    return(response)
}


async function getS3TempCred() {
    let response = await axios.get(baseUrl + "/get-s3");
    return response.data.Credentials;
}

async function getUsers() {
    let response = await axios.get(baseUrl + "/users",
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function getAllUsers(search) {
    let response = await axios.get(baseUrl + "/users/all",
        { 'headers': { 'search': search } });
    return response.data;
}

async function activateUser(data) {
    let response = await axios.post(baseUrl + "/users/activate-user", data,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function addUser(data) {
    let response = await axios.post(baseUrl + "/users", data,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function deleteUser(id) {
    await axios.delete(baseUrl + "/users/" + id,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
}

async function updateUser(data) {
    await axios.put(baseUrl + "/users/" + data.id, data,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
}

async function getVideos() {
    let response = await axios.get(baseUrl + "/videos",
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function getVideoForAdmin() {
    let response = await axios.get(baseUrl + "/videos/get-videos-for-admin", 
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function getVideoById(id) {
    let response = await axios.get(baseUrl + "/videos/" + id,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function addVideo(data) {
    let response = await axios.post(baseUrl + "/v2/videos", data,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function deleteVideo(id) {
    await axios.delete(baseUrl + "/videos/" + id,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
}

async function updateVideo(id, data) {
    await axios.put(baseUrl + "/videos/" + id, data,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
}

async function getWatchHistory(startDate, endDate) {
    let response = await axios.get(baseUrl + "/watch-history?startDate=" +
        startDate.toISOString().substr(0, 10) + '&endDate=' + endDate.toISOString().substr(0, 10),
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function getSessionDetails(sessionId) {
    let response = await axios.get(baseUrl + "/watch-history/" + sessionId,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function sendCommment(data) {
    let response = await axios.post(baseUrl + "/watch-history/comments",
        data,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function getScoringLogic() {
    let response = await axios.get(baseUrl + '/videos/scoring/scoring-logic');
    return response.data;
}

async function getDashboardData(startDate, endDate) {
    const responses = await Promise.all([
        axios.get(baseUrl + '/dashboard/total-users', { 'headers': { 'tenantId': store.state.selectedTenant } }),
        axios.get(baseUrl + '/dashboard/active-users?startDate=' + startDate.toISOString().substr(0, 10) + '&endDate=' +
            endDate.toISOString().substr(0, 10), { 'headers': { 'tenantId': store.state.selectedTenant } })
    ]);
    return responses.map(r => r.data);
}
async function addTenant(tenant) {
    let response = await axios.post(baseUrl + '/tenants', tenant);
    return response.data;
}

async function getAllTenants() {
    let response = await axios.get(baseUrl + '/tenants');
    return response.data;
}

async function getAllUsageSummary(data, obj) {
    let response = await axios.post(baseUrl + '/usersdata/get-data', data, obj);
    return response.data;
}

async function removeTenant(tenant) {
    let response = await axios.delete(baseUrl + '/tenants/' + tenant.id);
    return response.data;
}

async function getTenantDetails(tenantId) {
    let response = await axios.get(baseUrl + '/tenants/byid/' + tenantId);
    return response.data;
}

async function updateTenant(tenantId, tenant) {
    let response = await axios.put(baseUrl + '/tenants/' + tenantId, tenant);
    return response.data;
}

async function getTenantDataById(id) {
    let response = await axios.get(baseUrl + "/tenants/ById");
    return response.data;
}

async function resetApiKeys(tenantId) {
    let response = await axios.put(baseUrl + "/tenants/resetapikey/" + tenantId);
    return response.data;
}

async function updateTrainer(data) {
    let response = await axios.put(baseUrl + '/tenants', data,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function getTrainerProfile() {
    let response = await axios.get(baseUrl + '/tenants/ProfileByTenantId',
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}
async function getTenantData() {
    let response = await axios.get(baseUrl + '/trainer-admin',
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function getTrainerVideos() {
    let response = await axios.get(baseUrl + '/trainer-admin/videos',
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function getCategories() {
    let response = await axios.get(baseUrl + '/trainer-admin/categories');
    return response.data;
}

async function getLeaderBoard(org, data) {
    let response = await axios.post(baseUrl + '/corporate/corpLeaderboard/' + org, data,
        { 'headers': { 'tenantId': store.state.selectedTenant } });
    return response.data;
}

async function updateFilter(data) {
    let response = await axios.post(baseUrl + '/corporate/update-filters', data);
    return response.data;
}

async function getPopularWorkouts() {
    let response = await axios.get(baseUrl + '/recommendation/popular-videos');
    return response.data;
}
async function getTrendingWorkouts() {
    let response = await axios.get(baseUrl + '/recommendation/trending-videos');
    return response.data;
}

async function getTestingResult(videoId) {
    let response = await axios.get(baseUrl + '/videos/testing-results/'+ videoId);
    return response.data
}

async function getAllTestingResult(tenant_id) {
    let response = await axios.get(baseUrl + `/videos/automation-testing-result/${tenant_id}`);
    return response.data
}


async function getLatestVideos(tenant_id){
    let response = await axios.get(baseUrl + `/videos/latest-videos/${tenant_id}`);
    return response.data;
}

async function getAnyTestData() {
    let response = await axios.get(baseUrl + '/videos/get-any-tested-results');
    return response.data;
}

async function startVideoTesting(data) {
    let response = await axios.post(baselineMachineUrl+ '/test-any-video', data);
    return response.data;
}

async function bulkUploadVideos(data, tenantId) {
    let response = await axios.post(baselineMachineUrl + '/bulk-upload', data,
        { 'headers': {
            'Content-Type': 'multipart/form-data',
            'tenantId': store.state.selectedTenant
        }
    })
    return response.data;
}

async function deployVideos(data, tenantId) {
    let response = await axios.post(baselineMachineUrl + '/deploy-videos', data,
        { 'headers': {
            'Content-Type': 'multipart/form-data',
            'tenantId': store.state.selectedTenant
        }
    })
    return response.data;
}

async function getTopClients(queryParams){
    let response = await axios.get(baseUrl + '/report/top-clients' ,{
        params: queryParams
      });
    return response.data
}

async function allClients(queryParams){
    let response = await axios.get(baseUrl + '/report/clients' ,{
        params: queryParams
      });
    return response.data
}

async function weeklyChallenge(queryParams){
    let response = await axios.get(baseUrl + '/report/corporate-weekly-challenge' ,{
        params: queryParams
      });
    return response.data
}

async function corporateUserSummary(queryParams){
    let response = await axios.get(baseUrl + '/report/corporate-users/summary' ,{
        params: queryParams
      });
    return response.data
}

async function corporateClientList(){
    let response = await axios.get(baseUrl + '/report/client-list');
    return response.data
}

async function corporateUserSearch(queryParams){
    let response = await axios.get(baseUrl + '/report/user-search' ,{
        params: queryParams
      });
    return response.data
}

async function corporateUsers(queryParams){
    let response = await axios.get(baseUrl + '/report/corporate-users' ,{
        params: queryParams
      });
    return response.data
}

async function corporateUsersDetails(queryParams) {
    let response = await axios.get(baseUrl + '/report/corporate-users-details' ,{
        params: queryParams
      });
    return response.data
}

async function corporateWorkouts(queryParams) {
    let response = await axios.get(baseUrl + '/report/corporate-workouts' ,{
        params: queryParams
      });
    return response.data
}

async function getSessionData(requestData) {
    let response = await axios.post(baseUrl + '/video-test/get-session-data', requestData);
    return response.data;
}

async function getTrainerData(baseline_folder) {
    let response = await axios.post(baseUrl + '/video-test/get-trainer-data', {"baseline_folder": baseline_folder});
    return response.data;
}

async function getScoreData(sessionId) {
    let response = await axios.post(baseUrl + '/video-test/get-session-score', {'sessionId': sessionId});
    return response.data;
}

async function addNotification(data){
    let response = await axios.post(baseUrl + "/notification/send-notification-queue", data);
    return response.data;
}

async function sendUserNotification(data){
    let response = await axios.post(baseUrl + "/notification/send-in-app-notification", data);
    return response.data;
}

async function sendTopicNotification(data){
    let response = await axios.post(baseUrl + "/notification/send-push-notification", data);
    return response.data;
}

async function loadNotification(data){
    let response = await axios.post(baseUrl + "/notification/notification-list", data);
    return response.data;
}

async function loadNotificationV2(data){
    let response = await axios.post(baseUrl + "/notification/notification-list-v2", data);
    return response.data;
}

async function loadUserNotification(data){
    let response = await axios.post(baseUrl + "/notification/notification-users", data);
    return response.data;
}


async function deleteNotification(notificationId) {
    const response = await axios.delete(baseUrl + `/notification/delete-notification/${notificationId}`);
    return response.data;
}

async function submitRequestForm(data) {
    let response = await axios.post(baseUrl + "/email/request-for-demo", data);
    return response;
}

async function repCounter(data, baseline_folder) {
    let response = await axios.post(baseUrl + `/videos/rep_counter?baselineFolder=${baseline_folder}&fetchFromDB=false`, data);
    return response;
}

// Support Content API
async function getSupportContent({search, page, pageSize}) {
    let response = await axios.get(baseUrl + `/admin/support-content?search=${search}&pageSize=${pageSize}&page=${page}`);
    return response
}

async function createSupportContent(body) {
    let response = await axios.post(baseUrl + `/admin/support-content`, body);
    return response
}

async function updateSupportContent(id, updatedBody) {
    let response = await axios.put(baseUrl + `/admin/support-content/${id}`, updatedBody);
    return response;
}

async function deleteSupportContent(id) {
    let response = await axios.delete(baseUrl + `/admin/support-content/${id}`);
    return response;
}

async function getAllTeamLeaderboard(){
    let response = await axios.get(
      baseUrl + "/corporate/leaderboard/team");
    return response.data;
}

async function getTeamsLeaderboard(accessCode){
    let response = await axios.get(baseUrl + `/corporate/leaderboard/team/${accessCode}`);
    return response.data;
}

async function getAllUsersLeaderboard(){
    let response = await axios.get(baseUrl + `/corporate/leaderboard/user`);
    return response.data;
}

async function fetchFilters(){
    let response = await axios.get(baseUrl + `/corporate/filters`);
    return response.data;
}

async function fetchTeams(){
     let response = await axios.get(baseUrl + `/corporate/team`);
     return response.data;
}

export default {
    getS3TempCred, getUsers, addUser, activateUser, deleteUser, updateUser,
    getVideos, getVideoForAdmin, getVideoById, addVideo, deleteVideo, updateVideo,
    getWatchHistory, getSessionDetails, sendCommment, getScoringLogic, getDashboardData,
    addTenant, removeTenant,
    getTenantDetails,
    getTenantDataById, getAllTenants,
    updateTenant, resetApiKeys, updateTrainer,
    getTenantData, getTrainerProfile, getTrainerVideos, getCategories, getLeaderBoard, updateFilter,
    getAllCampaignDetails,deleteCampaign,updateCampaign,createCampaign,getCampaignById,
    getPopularWorkouts, getTrendingWorkouts, getAllUsageSummary, getTestingResult, getAllTestingResult,
    getLatestVideos, getAnyTestData, startVideoTesting, bulkUploadVideos, deployVideos,
    getPopularWorkouts, getTrendingWorkouts, getAllUsageSummary, getTestingResult, 
    getTopClients, allClients, weeklyChallenge, corporateUsers, corporateWorkouts, corporateUserSummary, corporateClientList, corporateUserSearch,
    getSessionData, getTrainerData, getScoreData,
    addNotification, loadNotification, loadUserNotification, submitRequestForm, repCounter ,getSupportContent, createSupportContent, updateSupportContent, deleteSupportContent,getAllUsers ,loadNotificationV2 ,sendTopicNotification, sendUserNotification ,deleteNotification,
    getAllTeamLeaderboard, getTeamsLeaderboard, getAllUsersLeaderboard, fetchFilters, fetchTeams
};

axios.interceptors.request.use(function (config) {
    let token = localStorage.getItem("token");

    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    };

    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => { return response }, function (error) {

    const status = error.response ? error.response.status : null

    if (status === 401) {
        return refreshToken().then(_ => {
            const accessToken = localStorage.getItem('token');
            error.config.headers['Authorization'] = 'Bearer ' + accessToken;
            error.config.baseURL = undefined;
            return instance.request(error.config);
        }).catch(e => {
            if (e.response.status == 401) {
                if (JSON.parse(localStorage.getItem['userInfo']).isAnonymousUser != 'true') {
                    store.dispatch('logout');
                    alert('Your session has expired. Please login again.');
                    router.push("/ef/sign-in");
                }
                return Promise.reject(e);
            }
        });
    }

    return Promise.reject(error);
});